import { Box, Stack, Typography } from "@mui/material"
import { ChevronDown, ChevronUp } from "@untitled-ui/icons-react"

export function StatsWidgetLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        fontSize: "0.95rem",
      }}
    >
      {children}
    </Typography>
  )
}

export function StatsWidgetValue({
  children,
  color,
  align = "left",
}: {
  children: React.ReactNode
  color: string
  align?: "left" | "center" | "right"
}) {
  return (
    <Typography
      sx={{
        fontSize: "1.5rem",
        color,
        textAlign: align,
      }}
    >
      {children}
    </Typography>
  )
}

export function StatsWidgetChange({
  children,
  delta,
  value,
}: {
  children: React.ReactNode
  delta: -1 | 1
  value: string
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.2}>
      {delta === 1 ? <ChevronUp color="success.main" /> : <ChevronDown color="error.main" />}
      <Typography
        sx={{
          fontSize: "0.85rem",
          color: delta === 1 ? "success.main" : "error.main",
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          fontSize: "0.85rem",
          color: "text.secondary",
        }}
      >
        {children}
      </Typography>
    </Stack>
  )
}

export function StatsWidget({ children }: { children: React.ReactNode }) {
  return <Box>{children}</Box>
}
